import { SearchableDropdown } from './SearchableDropdown';

interface TourDropdownProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export function TourDropdown({
  value,
  onChange,
  placeholder = 'Select Tour',
  className,
}: TourDropdownProps) {
  return (
    <SearchableDropdown
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      searchPlaceholder="Search tours..."
      className={className}
      endpoint="tours"
      emptyText="No tours found."
    />
  );
}
